@import './pk-simple-header.variables';

:host {
  @apply block w-full;
}

.wrapper {
  @apply flex h-[--simple-header--height] min-h-[--simple-header--height] w-[--simple-header--width] items-stretch justify-center;
  @apply box-border bg-[color:--simple-header--bg-color] bg-[image:--simple-header--bg-img] bg-cover p-s;
}

.title-container {
  @apply -my-[--pk-spacing-s] mx-0 flex-1 items-stretch overflow-hidden pr-s md:pr-xl3;
}

.title {
  @apply mx-0 my-auto overflow-hidden text-ellipsis font-bold text-l leading-m text-[color:--simple-header--title-color] [-webkit-box-orient:vertical] [-webkit-line-clamp:2] [display:-webkit-box];
  @apply md:block md:whitespace-nowrap md:text-xl;
}

.with-sponsor {
  .sponsor-container {
    ::slotted(*) {
      @apply max-h-full;
    }
  }

  .close-container {
    @apply m-0;
  }
}
